import api from "../../services/api";

const APIS = {
  GET_USERS: "/Users/all-phibrousers",
  DELETE_USER: "/Users/deluser",
  APPROVE_USER: "/Users/approve",
  HIDE_USERS: "/Users/hideuser",
  ADD_USER: "/Users/add-user",
  UPDATE_USER: "/Users/edit-user",
  GET_ALL_ROLES: "/Role",
  GET_LOCATIONS: "/Location/phibro-locations"

};

export const getUsers = async (pageNumber = 1, pageSize = 10, filterText = '') => {
  try {
    let url = `${APIS.GET_USERS}?PageNumber=${pageNumber}&PageSize=${pageSize}`;
    if (filterText?.trim()) {
      url += `&FilterText=${encodeURIComponent(filterText.trim())}`;
    }

    const res = await api.get(url);
    return {     
      results: res.data,
      totalCount: res.data.totalCount || 0,
      success: true
    };
  } catch (error) {
    console.error("Get users error:", error);
    return { results: [], totalCount: 0, success: false };
  }
};

export const approveUser = async (email, active) => {
  try {
    const res = await api.post(
      `${APIS.APPROVE_USER}/${encodeURIComponent(email?.trim().toLowerCase() || "")}/${active}`
    );
    return { success: true, data: res.data };
  } catch (error) {
    console.error("Approve user error:", error);
    return { success: false, error };
  }
};

export const deleteUser = async (email) => {
  try {
    const res = await api.post(
      `${APIS.DELETE_USER}/${encodeURIComponent(email?.trim().toLowerCase() || "")}`
    );
    return { success: true, data: res.data };
  } catch (error) {
    console.error("Delete user error:", error);
    return { success: false, error };
  }
};
export const hideUser = async (email) => {
  try {
    const res = await api.post(
      `${APIS.HIDE_USERS}/${encodeURIComponent(email?.trim().toLowerCase() || "")}`
    );
    return { success: true, data: res.data };
  } catch (error) {
    console.error("Hide user error:", error);
    return { success: false, error };
  }
};

export const addUser = async (userData) => {
  try {
    const res = await api.post(APIS.ADD_USER, { ...userData, email: userData.email?.trim().toLowerCase() || "" });
    return { success: true, data: res.data };
  } catch (error) {
    console.error("Add user error:", error);
    return { success: false, error };
  }
};

export const updateUser = async (userData) => {
  const normalizedData = { ...userData, email: userData.email?.trim().toLowerCase() || "" };
  try {
    const res = await api.post(APIS.UPDATE_USER, normalizedData);
    return { success: true, data: res.data };
  } catch (error) {
    // Some environments expose edit endpoint as POST, so retry once with POST for compatibility.
    const status = error?.response?.status;
    if (status === 404 || status === 405) {
      try {
        const fallbackRes = await api.post(APIS.UPDATE_USER, normalizedData);
        return { success: true, data: fallbackRes.data };
      } catch (fallbackError) {
        console.error("Update user fallback error:", fallbackError);
        return { success: false, error: fallbackError };
      }
    }

    console.error("Update user error:", error);
    return { success: false, error };
  }
};

export const getAllRoles = async () => {
  try {
    const res = await api.get(APIS.GET_ALL_ROLES);
    return { success: true, data: res.data };
  } catch (error) {
    console.error("Get all roles error:", error);
    return { success: false, error };
  }
};

export const getLocations = async (pageNumber = 1, pageSize = 1000, filterText = '') => {
    try {
        const res = await api.get(APIS.GET_LOCATIONS);

        const locations = Array.isArray(res.data) ? res.data : [];

        return {
            results: locations,
            totalCount: locations.length,
            success: true
        };
    } catch (error) {
        return { results: [], totalCount: 0, success: false };
    }
};